module.exports = __webpack_public_path__ + "img/royal-rider.7f98f855.png";